import {Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "@shared/services/web/toastr.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {AuthenticationService} from "@app/auth/authentication.service";
import {IMeta, MetaService} from "@shared/services/web/meta.service";

@Component({
  selector: 'app-recover-password-finish',
  templateUrl: './recover-password-finish.component.html',
  styleUrls: ['./recover-password-finish.component.scss']
})
export class RecoverPasswordFinishComponent {
  @ViewChild('RecuperacionExitosa', { static: false }) contenidoDelModal: any;

  closeDialog: String;
  recoverForm!: FormGroup;
  hash = '';
  userEmail = '';
  isChecking = false;
  showPassword = true;
  verified = false;
  isLoading = false;
  error = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public modalService: NgbModal,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    public authService: AuthenticationService,
    private metaService: MetaService
  ) {
    this.hash = this.activatedRoute.snapshot.paramMap.get('hash');
    this.changeMeta();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeMeta();
    });
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'recover_pass_hash',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit() {
    this.checkHash();
  }

  createForm() {
    this.recoverForm = this.formBuilder.group({
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-ZñÑa-z\\d!¡?¿$%@#£€*&^<>()+-_{}]{8,}$'
          ),
          Validators.minLength(8),
          Validators.maxLength(20),
        ]),
      ],
      reenterPass: ['', Validators.required],
    });
  }

  openLg() {
    this.modalService.open(this.contenidoDelModal, {
      size: 'lg',
      centered: true,
    });
  }

  openDialog(modal: any) {
    this.modalService
      .open(modal, { ariaLabelledBy: 'modal-nasic-title' })
      .result.then(
      (result) => {
        this.closeDialog = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeDialog = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getDismissReason(reason?: any) {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  hidePassword() {
    this.showPassword = !this.showPassword;
  }

  matchPasswords(): boolean {
    return (
      this.recoverForm.get('password').value ===
      this.recoverForm.get('reenterPass').value
    );
  }

  checkHash() {
    this.isChecking = true;
    this.authService.checkHashRecoverPassword(this.hash).subscribe(
      (data) => {
        this.createForm();
        this.userEmail = data.body.email;
        this.isChecking = false;
        this.verified = true;
        this.error = false;
      },
      (error) => {
        this.isChecking = false;
        this.error = true;
        this.verified = false;
        this.toastrService.error(error.error.message, 'Atención');
      }
    );
  }

  recoverPassword() {
    this.isLoading = true;
    this.authService
      .recoverPasswordFinish(this.recoverForm.value, this.userEmail, this.hash)
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.openLg();
          this.router.navigate(
            ['/' + this.translateService.currentLang, 'ingresar'],
            { replaceUrl: true }
          );
        },
        (error) => {
          this.isLoading = false;
          this.toastrService.error(error.error.message, 'Atención');
        }
      );
  }
}
